<app-header title="Adventure Programs"></app-header>

<div class="page-container">
  <mat-toolbar class="footer" color="primary" style="display: flex; flex-direction: row-reverse;">
    <button [disabled]="loading" mat-mini-fab color="white" (click)="openProgramDialog()">
      <mat-icon>add</mat-icon>
    </button>
  </mat-toolbar>

  <div class="filters-container">
    <mat-form-field class="filter-field">
      <mat-label>Search</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Search programs...">
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>

    <mat-form-field class="filter-field">
      <mat-label>Filter by Age</mat-label>
      <mat-select [(value)]="selectedAge" (selectionChange)="applyFilters()">
        <mat-option [value]="null">All Ages</mat-option>
        <mat-option *ngFor="let age of ageOptions" [value]="age">
          {{age}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="filter-field">
      <mat-label>Filter by Status</mat-label>
      <mat-select [(value)]="selectedStatus" (selectionChange)="applyFilters()">
        <mat-option [value]="null">All Status</mat-option>
        <mat-option [value]="true">Published</mat-option>
        <mat-option [value]="false">Unpublished</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="filter-field">
      <mat-label>Filter by Arcade Type</mat-label>
      <mat-select [(value)]="selectedArcadeType" (selectionChange)="applyFilters()">
        <mat-option [value]="null">All Types</mat-option>
        <mat-option *ngFor="let type of availableArcadeTypes" [value]="type">
          {{formatArcadeType(type)}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="cards-container">
    <div *ngIf="loading" class="loading-container">
      <mat-spinner></mat-spinner>
    </div>

    <div *ngIf="!loading && paginatedPrograms.length === 0" class="no-programs">
      No programs found
    </div>

    <div class="cards-grid">
      <mat-card *ngFor="let program of paginatedPrograms" class="program-card"
        [style.background-image]="'url(' + createImage(program.image) + ')'">
        <mat-card-header class="card-header">
          <mat-card-title class="card-title">{{program.name}}</mat-card-title>
        </mat-card-header>

        <mat-card-content class="card-content">
          <div class="info-row">
            <span class="label">Age:</span>
            <ng-container *ngFor="let age of program.ages; let i = index;">
              <span class="age-box">{{age}}</span>
            </ng-container>
          </div>
          <div class="info-row">
            <span class="label">Status:</span>
            <span class="value" [ngClass]="{'published': program.isPublished, 'unpublished': !program.isPublished}">
              {{program.isPublished ? 'Published' : 'Unpublished'}}
            </span>
          </div>
          <div class="info-row">
            <span class="label">Adventures:</span>
            <span class="value">{{ program.adventureIds.length }}</span>
          </div>
          <div class="info-row">
            <span class="label">Priority:</span>
            <span class="priority-tag" [style.background-color]="priorityColors[program.priority]">
              {{ priorityLabels[program.priority] }}
            </span>
          </div>
        </mat-card-content>

        <mat-card-actions class="card-actions">
          <span class="arcade-type">{{formatArcadeType(program.arcadeType)}}</span>
          <div class="action-buttons">
            <button *ngIf="enableEdit" mat-icon-button class="action-button" (click)="editProgram(program)">
              <mat-icon>edit</mat-icon>
            </button>
            <button *ngIf="enableDeletion" mat-icon-button class="action-button" (click)="deleteProgram(program.uid)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </mat-card-actions>
      </mat-card>
    </div>

    <mat-paginator [length]="totalItems" [pageSize]="defaultPageSize" [pageSizeOptions]="pageSizeOptions"
      (page)="paginatorChanged($event)" showFirstLastButtons>
    </mat-paginator>
  </div>
</div>